import React from 'react'
import { Folio, Book as BookType } from '@fable/types'
import { useDeviceDetect } from '@fable/hooks'
import { BookModal } from '../book_modal/BookModal'
import { FolioBook, PurchasedBook, RegularBook } from './variants'

import handleDeeplink from '../../../../../utils/handleDeeplink'
import { useActions } from '../../../../../hooks/useActions'
import { useTypedSelector } from '../../../../../hooks/useTypedSelector'
import { BOOK_APP_LINK } from '../../../../../constants'
import { useLocation } from 'react-router-dom'
import { bookRoute } from '../../../routes'
import altTag from '../../../../../utils/altTag'
import './Book.scss'

interface Props {
  customClass?: string
  book: BookType
  folioData?: Folio
  isOwned?: boolean
  selectedFolioBook?: (book: BookType) => void
  isDefaultAction?: boolean
}

export const Book: React.FC<Props> = ({
  customClass = '',
  book,
  folioData,
  isOwned,
  selectedFolioBook,
  isDefaultAction,
}) => {
  const { pathname } = useLocation()
  const { openModal } = useActions()
  const { isAuthenticated } = useTypedSelector(({ auth }) => auth)

  const { isMobile } = useDeviceDetect()

  const openBook = () => {
    const { id } = book
    const link = `${BOOK_APP_LINK}/${id}`

    if (isMobile) {
      handleDeeplink(link)
    } else {
      const modalContent = <BookModal book={book} isOwned={isOwned} />
      openModal(modalContent)
    }
  }

  const bookClass = `${customClass} fds-ui--book book fade`
  const bookLink = {
    pathname: bookRoute(book),
    state: { prevPath: pathname },
  }

  const renderBook = () => {
    if (isOwned && !folioData) {
      return (
        <PurchasedBook
          book={book}
          customClass={bookClass}
          openBook={openBook}
          path={bookLink}
        />
      )
    }

    if (folioData) {
      return (
        <FolioBook
          book={book}
          customClass={bookClass}
          onSelect={() => selectedFolioBook && selectedFolioBook(book)}
          altTag={altTag.folioBook(folioData)}
        />
      )
    }

    return (
      <RegularBook
        book={book}
        customClass={bookClass}
        isAuthenticated={isAuthenticated}
        isDefaultAction={isDefaultAction}
        openBook={openBook}
        path={bookLink}
      />
    )
  }

  return renderBook()
}
